"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPageControlProvider = void 0;
const react_1 = __importDefault(require("react"));
const PageGroupWrapper_1 = __importDefault(require("./PageGroupWrapper"));
const PageHelpers_1 = require("./PageHelpers");
const RepeatPageWrapper_1 = __importDefault(require("./RepeatPageWrapper"));
const RepeatPageFieldWrapper_1 = __importDefault(require("./RepeatPageFieldWrapper"));
const GridWrapper_1 = __importDefault(require("./GridWrapper"));
const GridElementWrapper_1 = __importDefault(require("./GridElementWrapper"));
const TGPageTextField_1 = __importDefault(require("../PageFields/TGPageTextField"));
const PageRootWrapper_1 = __importDefault(require("./PageRootWrapper"));
const StyleWrapper_1 = __importDefault(require("./StyleWrapper"));
const TGPageDateTimeField_1 = __importDefault(require("../PageFields/TGPageDateTimeField"));
const TGPageDateField_1 = __importDefault(require("../PageFields/TGPageDateField"));
const TGPageTimeField_1 = __importDefault(require("../PageFields/TGPageTimeField"));
const TGPageMediaField_1 = __importDefault(require("../PageFields/TGPageMediaField"));
const TGPageChartField_1 = __importDefault(require("../PageFields/TGPageChartField"));
/**
 * This is a higher order component that wraps a repeatable component instance and determines its visibility based on the current context and props
 * Its main responsibility is to hide repeated elements if the repeat is collapsed
 * @param Component The UI component to wrap
 */
const withPageRepeatable = (Component) => {
    return (props) => {
        const { 
        // multiline, we will reuse it maybe later
        repeatable, index, repeatCount, controlDefinition, onAddClick, onRemoveClick, moveItems, isOriginal, value, values, } = props;
        return repeatable ? (react_1.default.createElement(RepeatPageFieldWrapper_1.default, { onAddClick: onAddClick, onRemoveClick: onRemoveClick, controlDefinition: controlDefinition, repeatable: repeatable, index: index, repeatCount: repeatCount, moveItems: moveItems, isOriginal: isOriginal, value: value, values: values },
            react_1.default.createElement(Component, Object.assign({}, props)))) : (react_1.default.createElement("div", null,
            react_1.default.createElement(Component, Object.assign({}, props))));
    };
};
const PageControlProvider = {
    RootWrapper: PageRootWrapper_1.default,
    GroupWrapper: PageGroupWrapper_1.default,
    RepeatWrapper: RepeatPageWrapper_1.default,
    GridWrapper: GridWrapper_1.default,
    GridElementWrapper: GridElementWrapper_1.default,
    StyleWrapper: StyleWrapper_1.default,
    text: withPageRepeatable((0, PageHelpers_1.withPageTextFieldProps)(TGPageTextField_1.default)),
    number: withPageRepeatable((0, PageHelpers_1.withPageNumberFieldProps)(TGPageTextField_1.default)),
    time: withPageRepeatable((0, PageHelpers_1.withPageTimeFieldProps)(TGPageTimeField_1.default)),
    date: withPageRepeatable((0, PageHelpers_1.withPageDateFieldProps)(TGPageDateField_1.default)),
    datetime: withPageRepeatable((0, PageHelpers_1.withPageDateFieldProps)(TGPageDateTimeField_1.default)),
    file: withPageRepeatable((0, PageHelpers_1.withFileFieldProps)(TGPageMediaField_1.default)),
    image: withPageRepeatable((0, PageHelpers_1.withImageFieldProps)(TGPageMediaField_1.default)),
    chart: withPageRepeatable((0, PageHelpers_1.withChartFieldProps)(TGPageChartField_1.default)),
};
exports.default = PageControlProvider;
const createPageControlProvider = (props) => {
    const { translateFunction = text => text } = props;
    /**
     * This is a higher order component that wraps a repeatable component instance and determines its visibility based on the current context and props
     * Its main responsibility is to hide repeated elements if the repeat is collapsed
     * @param Component The UI component to wrap
     */
    const withPageRepeatable = (Component) => {
        return (props) => {
            const { 
            // multiline, we will reuse it maybe later
            repeatable, index, repeatCount, controlDefinition, onAddClick, onRemoveClick, moveItems, isOriginal, value, values, } = props;
            return repeatable ? (react_1.default.createElement(RepeatPageFieldWrapper_1.default, { onAddClick: onAddClick, onRemoveClick: onRemoveClick, controlDefinition: controlDefinition, repeatable: repeatable, index: index, repeatCount: repeatCount, moveItems: moveItems, isOriginal: isOriginal, value: value, values: values },
                react_1.default.createElement(Component, Object.assign({}, props)))) : (react_1.default.createElement("div", null,
                react_1.default.createElement(Component, Object.assign({}, props))));
        };
    };
    return {
        RootWrapper: PageRootWrapper_1.default,
        RepeatWrapper: RepeatPageWrapper_1.default,
        GridWrapper: GridWrapper_1.default,
        GridElementWrapper: GridElementWrapper_1.default,
        StyleWrapper: StyleWrapper_1.default,
        GroupWrapper: (0, PageHelpers_1.withPageGroupProps)(PageGroupWrapper_1.default, translateFunction),
        text: withPageRepeatable((0, PageHelpers_1.withPageTextFieldProps)(TGPageTextField_1.default, translateFunction)),
        number: withPageRepeatable((0, PageHelpers_1.withPageNumberFieldProps)(TGPageTextField_1.default, translateFunction)),
        time: withPageRepeatable((0, PageHelpers_1.withPageTimeFieldProps)(TGPageTimeField_1.default, translateFunction)),
        date: withPageRepeatable((0, PageHelpers_1.withPageDateFieldProps)(TGPageDateField_1.default, translateFunction)),
        datetime: withPageRepeatable((0, PageHelpers_1.withPageDateFieldProps)(TGPageDateTimeField_1.default, translateFunction)),
        file: withPageRepeatable((0, PageHelpers_1.withFileFieldProps)(TGPageMediaField_1.default, translateFunction)),
        image: withPageRepeatable((0, PageHelpers_1.withImageFieldProps)(TGPageMediaField_1.default, translateFunction)),
        chart: withPageRepeatable((0, PageHelpers_1.withChartFieldProps)(TGPageChartField_1.default, translateFunction)),
    };
};
exports.createPageControlProvider = createPageControlProvider;
//# sourceMappingURL=PageControlProvider.js.map